import React from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";
import { Modal, Button } from "react-bootstrap";

function ModalFormulas(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});


    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [formulaSeleccionada, setFormulaSeleccionada] = useState(null);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false); // 🆕 Modal post-guardado

    // 🎯 ESTADOS PARA ACORDEONES REACT
    const [acordeonFechaHora, setAcordeonFechaHora] = useState(true);
    const [acordeonContenido, setAcordeonContenido] = useState(true);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-formulas', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        //cargaritems();

    }, []);


    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/formulas', config2)
            .then(response => {
                console.log('Respuesta formulas:', response.data);
                setHistorial(response.data);
                setConsolidado(construirHtmlConsolidadoFormulas(response.data));
            })
            .catch(error => {
                console.log('Error cargando formulas:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }



    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }




    const contenidoFormulaNoVacio = () => {
        if (contenido == null || String(contenido).trim() === '') return false;
        const t = String(contenido).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
        return t.length > 0;
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!fechaHora || !String(fechaHora).trim()) {
            alert('La fecha y hora son obligatorias.');
            return;
        }
        if (!contenidoFormulaNoVacio()) {
            alert('El contenido de la fórmula es obligatorio.');
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            firma: firmaimg,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        console.log('Enviando datos de formula:', data);

        axios.post('/formula', data, config)
            .then(response => {
                console.log('Formula guardada exitosamente:', response.data);
                setLoading(false);
                // ❌ ELIMINADO: props.guardarCambios('La fórmula ha sido agregada');
                setDeshabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({}); // Limpiar errores en caso de éxito

                // 🆕 Mostrar modal de confirmación post-guardado
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando formula:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })

    }


    const establecerFechaHoraActual = () => {
        const ahora = new Date();
        const fechaFormateada = ahora.toISOString().slice(0, 16);
        setFechaHora(fechaFormateada);
    }

    // 🆕 Función para generar encabezado personalizado HTML
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        // Función auxiliar para limpiar HTML y evitar saltos de línea innecesarios
        const limpiarHTML = (html) => {
            if (!html) return '';
            // Reemplazar <p> tags con divs para un control más preciso
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        // USAR TABLA EN LUGAR DE FLEXBOX PARA MEJOR COMPATIBILIDAD CON PDF
        // FONDO BLANCO Y SIN BORDES
        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <!-- Columna Izquierda (30%) -->
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <!-- Columna Centro (40%) -->
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <!-- Columna Derecha (30%) -->
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return { nombreCompleto: 'Paciente no identificado', documentoCompleto: '—' };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const rellenarSeccionesPdfFormulaItem = (secciones, formula) => {
        secciones.push({
            tipo: 'banner',
            titulo: 'FÓRMULA MÉDICA',
            contenido: 'FÓRMULA MÉDICA'
        });

        const profTrat = formula.profesional_tratante_completo &&
            formula.profesional_tratante_completo !== 'No registrado'
            ? formula.profesional_tratante_completo
            : 'No registrado';

        secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'FECHA Y HORA', valor: String(formula.fecha || '') },
                    { etiqueta: 'PROFESIONAL TRATANTE', valor: profTrat }
                ]
            }
        });

        const cuerpoHtml = (formula.contenido && String(formula.contenido).trim())
            ? formula.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        secciones.push({
            tipo: 'texto',
            titulo: 'FÓRMULA',
            contenido: cuerpoHtml
        });

        const tieneProf = formula.profesional_tratante_completo &&
            formula.profesional_tratante_completo !== 'No registrado';
        if (tieneProf && formula.profesional && formula.firma) {
            secciones.push({
                tipo: 'firma',
                imagenBase64: formula.firma,
                metadata: {
                    tipo: 'profesional',
                    nombre: formula.profesional || '',
                    registroMedico: formula.registro_medico || 'N/A',
                    codigoHabilitacion: formula.codigo_habilitacion || 'N/A'
                }
            });
        }
    };

    const construirConfigPdfFormulaNativo = (formula) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `formula-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };

        rellenarSeccionesPdfFormulaItem(config.secciones, formula);
        return config;
    };

    const construirConfigPdfFormulasConsolidadoNativo = () => {
        if (!historial || historial.length === 0) {
            return null;
        }
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `formulas-consolidado-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };

        config.secciones.push({
            tipo: 'banner',
            titulo: 'FÓRMULAS CONSOLIDADAS',
            contenido: 'FÓRMULAS CONSOLIDADAS'
        });

        historial.forEach((item, index) => {
            if (index > 0) {
                config.secciones.push({ tipo: 'salto-pagina' });
            }
            rellenarSeccionesPdfFormulaItem(config.secciones, item);
        });

        return config;
    };

    /** Cuerpo de un ítem: mismo orden que el PDF nativo (sin PACIENTE/DOC: va en el helper). */
    const construirHtmlCuerpoFormulaItem = (formula) => {
        const profTrat = formula.profesional_tratante_completo &&
            formula.profesional_tratante_completo !== 'No registrado'
            ? formula.profesional_tratante_completo
            : 'No registrado';

        const banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    FÓRMULA MÉDICA
                </div>
            </div>`;

        const tablaFechaProf = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${formula.fecha || ''}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${profTrat}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const cuerpoHtml = (formula.contenido && String(formula.contenido).trim())
            ? formula.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        const bloqueFormula = `
            <div style="margin-bottom: 12px;">
                <div style="font-size: 11px; font-weight: bold; color: #325e68; margin-bottom: 8px; letter-spacing: 0.02em;">FÓRMULA</div>
                <div style="border: 1px solid #dee2e6; border-radius: 2px; padding: 12px; background: #ffffff; font-size: 13px; line-height: 1.45;">
                    ${cuerpoHtml}
                </div>
            </div>`;

        const tieneProf = formula.profesional_tratante_completo &&
            formula.profesional_tratante_completo !== 'No registrado';
        let bloqueFirma = '';
        if (tieneProf && formula.profesional && formula.firma) {
            bloqueFirma = `
                <div style="margin-top: 8px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6; vertical-align: top;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                    <img src="${formula.firma}" alt="Firma" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 8px; font-size: 12px; color: #6c757d;">
                                        ${formula.profesional}<br/>
                                        <strong>RM:</strong> ${formula.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${formula.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        return banner + tablaFechaProf + bloqueFormula + bloqueFirma;
    };

    const construirHtmlVistaFormulaNativa = (formula) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const tablaPacienteDoc = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        return encabezadoPrev +
            '<div class="vista-formula-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            tablaPacienteDoc +
            construirHtmlCuerpoFormulaItem(formula) +
            '</div>';
    };

    const construirHtmlConsolidadoFormulas = (items) => {
        if (!items || items.length === 0) {
            return '';
        }
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const tablaPacienteDoc = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;
        const titulo = '<h1 style="text-align: center; margin-bottom: 16px; font-size: 1.25rem; color: #323a45;">FÓRMULAS CONSOLIDADAS</h1>';
        let bloques = '';
        items.forEach((item, i) => {
            if (i > 0) {
                bloques += '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;" />';
            }
            bloques += `<div style="page-break-inside: avoid;">${construirHtmlCuerpoFormulaItem(item)}</div>`;
        });
        return encabezadoPrev +
            '<div class="consolidado-formulas-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            tablaPacienteDoc +
            titulo +
            bloques +
            '</div>';
    };

    const verFormula = (formula) => {
        setTituloResumen('Fórmula Médica - Vista Previa');
        setFormulaSeleccionada(formula);
        setContenidoResumenIndividual(construirHtmlVistaFormulaNativa(formula));
        setShowModalResumen(true);
    };

    const nuevaFormula = () => {
        // Limpiar formulario para nueva fórmula
        setFormulaSeleccionada(null);
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        // Acordeones abiertos por defecto (cabecera sigue siendo clicable para plegar)
        setAcordeonFechaHora(true);
        setAcordeonContenido(true);

        // Limpiar formulario
        if (document.getElementById('plantillas')) {
            document.getElementById('plantillas').value = "";
        }
    }

    const descargarPdfFormula = async () => {
        if (!formulaSeleccionada) return;

        try {
            const config = construirConfigPdfFormulaNativo(formulaSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            const name = config.filename || 'formula-' + (props.docPaciente || 'paciente') + '.pdf';
            pdf.save(name);
        } catch (err) {
            console.error('PDF nativo fórmula (descarga):', err);
            alert('No se pudo generar el PDF. Intente de nuevo.');
        }
    };

    const descargarPdfConsolidado = async () => {
        const config = construirConfigPdfFormulasConsolidadoNativo();
        if (!config) {
            alert('No hay fórmulas en el historial para exportar.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename || 'formulas-consolidado.pdf');
        } catch (err) {
            console.error('PDF nativo consolidado fórmulas:', err);
            alert('No se pudo generar el PDF consolidado. Intente de nuevo.');
        }
    };

    const imprimirPdfConsolidado = async () => {
        const config = construirConfigPdfFormulasConsolidadoNativo();
        if (!config) {
            alert('No hay fórmulas en el historial para imprimir.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                window.open(url, '_blank');
            }
        } catch (err) {
            console.error('Imprimir PDF nativo consolidado fórmulas:', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    const imprimirFormula = async () => {
        if (!formulaSeleccionada) {
            alert('No hay fórmula seleccionada para imprimir');
            return;
        }

        try {
            const config = construirConfigPdfFormulaNativo(formulaSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Descargue el PDF e imprímalo desde su visor.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        } catch (err) {
            console.error('PDF nativo fórmula (imprimir):', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    // 🆕 Funciones del Modal de Confirmación
    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        nuevaFormula();
        // No guardarCambios(msg): en AtenderPaciente2 solo dispara un toast duplicado del mismo mensaje.
        // El historial ya se actualizó con cargaritems() al guardar.
    };

    // 🆕 Función para cerrar el modal de vista previa y limpiar recursos
    const cerrarModalResumen = () => {
        // Limpiar blob URL si existe
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.src && iframe.src.startsWith('blob:')) {
            URL.revokeObjectURL(iframe.src);
        }
        setShowModalResumen(false);
    };

    /** Vista previa en iframe: mismo PDF nativo que descarga / imprime (texto paginado, sin html2canvas). */
    const verResumen = async (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);
        setFormulaSeleccionada(resumenIndividual);

        try {
            const config = construirConfigPdfFormulaNativo(resumenIndividual);
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const iframeHTML = `<iframe src="${url}" style="width: 100%; height: 600px; border: none;"></iframe>`;
            setContenidoResumenIndividual(iframeHTML);
            setShowModalResumen(true);
        } catch (err) {
            console.error('Vista previa PDF nativo fórmula:', err);
            alert('No se pudo generar la vista previa en PDF.');
        }
    };


    useEffect(() => {
        cargaritems();

        // Cleanup para evitar memory leaks
        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
            setFormulaSeleccionada(null);
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `formulas.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 4, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let formulasCompleta = "<img src='" + logoImg + "' className='app-logo-pdf' /><h1 className='ttl-pdf'>FÓRMULAS MÉDICAS</h1>" + anamnesis + "<div className='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(formulasCompleta, opt);
    }


    if (loggedIn) {
        return (


            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* 🆕 PROFESIONAL TRATANTE - Siempre visible */}
                                            <div className="col-md-12">
                                                <div className="card" style={{ marginBottom: '15px' }}>
                                                    <div className="card-body" style={{ padding: '15px' }}>
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza la fórmula</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonFechaHora(!acordeonFechaHora)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100 mb-0">
                                                            <span className="d-block w-100">Fecha y Hora <span className="text-danger">*</span></span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonFechaHora ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <div className="form-group">
                                                            <label>Fecha y Hora <span className="text-danger">*</span></label>
                                                            <div className="input-group">
                                                                <input type="datetime-local" className="form-control" required value={fechaHora} onChange={(e) => setFechaHora(e.target.value)} />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonContenido(!acordeonContenido)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100 mb-0">
                                                            <span className="d-block w-100">Contenido de la Fórmula <span className="text-danger">*</span></span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonContenido ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <label style={{ fontSize: '1rem', marginBottom: '8px' }}>Seleccione la fórmula o digite su contenido <span className="text-danger">*</span></label>
                                                        <div className="form-group">
                                                            <select name="plantillas" className="form-control" id="plantillas" onChange={(e) => setContenido(e.target.value)} >
                                                                <option></option>
                                                                {
                                                                    plantillas.map((plantilla) =>
                                                                        <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        </div>
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.contenido}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label htmlFor="nombreProfesional">Firma</label>
                                                            <br></br>
                                                            <img src={firmaimg} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de fórmulas</b>

                                    {
                                        historial.map((item) =>

                                            <div className="timeline-item-container" key={item.id} onClick={() => verFormula(item)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-outline-secondary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>

                            </div>

                        </div>

                    </div>
                </section>

                <Modal show={showModalResumen} onHide={cerrarModalResumen} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: contenidoResumenIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" size="sm" onClick={imprimirFormula}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={descargarPdfFormula}>
                            <i className="fas fa-file-pdf mr-1"></i> Guardar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={cerrarModalResumen}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Resumen Fórmulas Médicas</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" size="sm" onClick={imprimirPdfConsolidado}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={descargarPdfConsolidado}>
                            <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={() => setShowModalConsolidado(false)}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* 🆕 Modal de Confirmación Post-Guardado */}
                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Fórmula guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            La fórmula ha sido guardada exitosamente. Puede abrirla desde el historial para vista previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalFormulas;